export const printTypeOptions = [
  { value: 'bw', label: 'Black and White', basePrice: 2.5 },
  { value: 'color', label: 'Color', basePrice: 6 },
];

export const paperSizeOptions = [
  { value: 'A4', label: 'A4', surcharge: 0 },
  { value: 'A3', label: 'A3', surcharge: 3 },
  { value: 'Letter', label: 'Letter', surcharge: 0 },
  { value: 'Legal', label: 'Legal', surcharge: 0 },
];

export const bindingOptions = [
  { value: 'Stick File', label: 'Stick File', price: 10 },
  { value: 'spiral', label: 'Spiral Binding', price: 49 },
  { value: 'saddle', label: 'Saddle Stitch', price: 29 },
  { value: 'perfect', label: 'Perfect Binding', price: 79 },
  { value: 'none', label: 'No Binding', price: 0 },
];

export const deliveryOptions = [
  { value: 'standard', label: 'Standard (1-2 days)', price: 0 },
  { value: 'express', label: 'Express Same-Day', price: 39 },
];

function getOption(options, value, fallbackValue) {
  return (
    options.find((option) => option.value === value) ||
    options.find((option) => option.value === fallbackValue) ||
    options[0]
  );
}

export function calculateOrderPricing(printOptions) {
  const copies = Math.max(1, Number(printOptions?.copies || 1));
  const pages = Math.max(1, Number(printOptions?.pages || 1));
  const printType = getOption(printTypeOptions, printOptions?.type, 'bw');
  const paperSize = getOption(paperSizeOptions, printOptions?.size, 'A4');
  const binding = getOption(bindingOptions, printOptions?.binding, 'none');
  const delivery = getOption(deliveryOptions, printOptions?.delivery, 'standard');

  const pricePerPage = printType.basePrice + paperSize.surcharge;
  const printCost = pricePerPage * pages * copies;
  const total = printCost + binding.price + delivery.price;

  return {
    copies,
    pages,
    printType,
    paperSize,
    binding,
    delivery,
    pricePerPage,
    printCost,
    total,
  };
}
